import { isZhLocale } from '@yoyoclub/shared';
import type { i18n as I18n } from 'i18next';

/**
 * Text for a failed waitlist request. Server messages are English, so Chinese
 * readers get the translation of the error code, or `fallbackKey` when the
 * code is unknown (a network failure has none).
 */
export function waitlistErrorText(err: unknown, i18n: I18n, fallbackKey: string): string {
  const code = (err as { code?: unknown } | null)?.code;
  const message = err instanceof Error ? err.message : '';
  if (!isZhLocale(i18n.language)) return message || i18n.t(`waitlist:${fallbackKey}`);
  const key = `waitlist:errors.${String(code)}`;
  return typeof code === 'string' && i18n.exists(key)
    ? i18n.t(key)
    : i18n.t(`waitlist:${fallbackKey}`);
}
